import { render } from "./SloganCircle.vue?vue&type=template&id=5698ea67&scoped=true"
const script = {}

import "./SloganCircle.vue?vue&type=style&index=0&id=5698ea67&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5698ea67"]])

export default __exports__